module.exports = __webpack_public_path__ + "static/media/login_background.66d2f8fd.jpg";